module.exports = __webpack_public_path__ + "static/media/regal-rush-white-bg-gold-400x240.4ac6e547.png";